import ClientLogger from '../../lib/logger';

const urlFromContent = (pageContent) => {
  if (!pageContent) return undefined;

  const downloadEntry = pageContent.find(
    (entry) => entry.contentJson && entry.contentJson.CodeActions
  );
  if (!downloadEntry) return undefined;

  const { buttons } = downloadEntry.contentJson.CodeActions.rows.find((row) =>
    row.buttons.find((button) => button.key === 'download')
  );
  if (!buttons || buttons.length < 1) return undefined;

  return buttons.find((button) => button.key === 'download').url;
};

export default ({ frontend, backend, pageContent, type, product }) => {
  if (!pageContent) return '';
  const downloadUrl = urlFromContent(pageContent);
  if (!downloadUrl) {
    ClientLogger.cal.error('CLIENT:ERROR', { error: 'Download url not found' });
    return '';
  }

  if (product === 'fastlane') {
    const urlPath = [frontend, backend, type].join('_');
    const url = downloadUrl[urlPath];
    return url;
  }
  if (typeof downloadUrl === 'string') return downloadUrl;

  const frontendUrls = downloadUrl[frontend];
  if (typeof frontendUrls === 'string') return frontendUrls;
  return frontendUrls?.[backend];
};
